import * as faceapi from "@vladmandic/face-api";

const MODEL_URL = "/models";
let loadPromise = null;

export function loadFaceModels() {
  if (!loadPromise) {
    loadPromise = (async () => {
      try {
        await faceapi.tf.setBackend("webgl");
        await faceapi.tf.ready();
      } catch (e) { /* fall back to default backend */ }
      await Promise.all([
        faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
        faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
        faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
      ]);
    })();
  }
  return loadPromise;
}

export async function getDescriptor(videoEl) {
  const det = await faceapi
    .detectSingleFace(videoEl, new faceapi.TinyFaceDetectorOptions({ inputSize: 288, scoreThreshold: 0.4 }))
    .withFaceLandmarks()
    .withFaceDescriptor();
  if (!det) return null;
  return Array.from(det.descriptor);
}

export async function detectEAR(videoEl, inputSize = 192) {
  const res = await faceapi
    .detectSingleFace(videoEl, new faceapi.TinyFaceDetectorOptions({ inputSize, scoreThreshold: 0.3 }))
    .withFaceLandmarks();
  if (!res) return null;
  const d = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
  const ear = (eye) => (d(eye[1], eye[5]) + d(eye[2], eye[4])) / (2 * d(eye[0], eye[3]));
  const l = res.landmarks.getLeftEye();
  const r = res.landmarks.getRightEye();
  return (ear(l) + ear(r)) / 2;
}
